/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_401_Timeout_Issue_DescriptionInputs */

const en_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page needs to be refreshed. Please reopen the event page.`)
};

const ar_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه الصفحة تحتاج إلى تحديث. يرجى إعادة فتح صفحة الحدث.`)
};

const de_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite muss neu geladen werden. Bitte öffnen Sie die Event-Seite erneut.`)
};

const es_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página necesita ser actualizada. Vuelva a abrir la página del evento.`)
};

const fr_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page doit être actualisée. Veuillez rouvrir la page de l'événement.`)
};

const it_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina deve essere aggiornata. Ti preghiamo di riaprire la pagina dell'evento.`)
};

const ja_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページは再読み込みが必要です。イベントページを再度開いてください。`)
};

const ko_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지를 새로고침해야 합니다. 이벤트 페이지를 다시 열어주세요.`)
};

const pt_br_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página precisa ser atualizada. Por favor, reabra a página do evento.`)
};

const ru_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эту страницу необходимо перезагрузить. Пожалуйста, откройте страницу события заново.`)
};

const th_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้านี้จำเป็นต้องรีเฟรช กรุณาเปิดหน้ากิจกรรมอีกครั้ง.`)
};

const tr_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfanın yenilenmesi gerekiyor. Lütfen etkinlik sayfasını yeniden açın.`)
};

const zh_cn_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此页面需要重新加载。请重新打开活动页面。`)
};

const zh_tw_dialog_401_timeout_issue_description = /** @type {(inputs: Dialog_401_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此頁面需要重新整理。請重新開啟活動網頁。`)
};

/**
* | output |
* | --- |
* | "This page needs to be refreshed. Please reopen the event page." |
*
* @param {Dialog_401_Timeout_Issue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_401_timeout_issue_description = /** @type {((inputs?: Dialog_401_Timeout_Issue_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_401_Timeout_Issue_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_401_timeout_issue_description(inputs)
	if (locale === "ar") return ar_dialog_401_timeout_issue_description(inputs)
	if (locale === "de") return de_dialog_401_timeout_issue_description(inputs)
	if (locale === "es") return es_dialog_401_timeout_issue_description(inputs)
	if (locale === "fr") return fr_dialog_401_timeout_issue_description(inputs)
	if (locale === "it") return it_dialog_401_timeout_issue_description(inputs)
	if (locale === "ja") return ja_dialog_401_timeout_issue_description(inputs)
	if (locale === "ko") return ko_dialog_401_timeout_issue_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_401_timeout_issue_description(inputs)
	if (locale === "ru") return ru_dialog_401_timeout_issue_description(inputs)
	if (locale === "th") return th_dialog_401_timeout_issue_description(inputs)
	if (locale === "tr") return tr_dialog_401_timeout_issue_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_401_timeout_issue_description(inputs)
	return zh_tw_dialog_401_timeout_issue_description(inputs)
});